export const CustomEventNames = Object.freeze({
  crm: {
    activities: {
      reloadActivityHome: 'reloadActivityHomeData',
    },
  },
  lighting: {
    reloadConfigHome: 'reloadLightingConfigHomeData',
  },
} as const);
